import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as CoinIcon } from 'src/assets/icons/bonus-game/coin.svg';

const SeasonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 20px 0;
`;

const SeasonTitle = styled.div`
  font-size: 14px;
  color: #b9f53a;
  margin-bottom: 8px;
  text-align: center;
`;

const SeasonContent = styled.div`
  background-color: #1a222c;
  border-radius: 16px;
  padding: 8px 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
`;

const SeasonCenterContent = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

const SeasonAmount = styled.div`
  display: flex;
  align-items: center;
  align-self: center;
  gap: 10px;
`;

const CoinWrapper = styled.div`
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Amount = styled.div`
  font-size: 30px;
  font-weight: 600;
  color: #ffffff;
`;

const ArrowIcon = styled.div`
  color: #4a5a6a;
  font-size: 24px;
`;

interface SeasonsProps {
  seasonRating?: number;
}

export const Seasons = ({ seasonRating }: SeasonsProps) => {
  const navigate = useNavigate();

  return (
    <SeasonWrapper>
      <SeasonContent onClick={() => navigate('/bonus-game/current-season')}>
        <SeasonCenterContent>
          <SeasonTitle>Season 2</SeasonTitle>
          <SeasonAmount>
            <CoinWrapper>
              <CoinIcon width={24} height={24} />
            </CoinWrapper>
            <Amount>{seasonRating}</Amount>
          </SeasonAmount>
        </SeasonCenterContent>
        <ArrowIcon>›</ArrowIcon>
      </SeasonContent>
    </SeasonWrapper>
  );
};
